<template>
  <div id="app">
    <div v-if="showIframe">
      <iframe allow="camera; microphone; geolocation; fullscreen; clipboard-read; clipboard-write; accelerometer; gyroscope; payment; display-capture; autoplay" sandbox="allow-same-origin allow-scripts allow-forms allow-modals allow-popups allow-downloads allow-presentation" :src="iframeSrc" style="width: 100%; height: calc(100vh - 50px); border: none;"></iframe>
    </div>
    <div v-else>
      <router-view @update-active="updateActive" />
    </div>
    
    <!-- 仅当不在 login 页时显示 Tabbar -->
    <van-tabbar v-if="showTabbar" v-model="active" active-color="rgb(100, 45, 113)" inactive-color="#999999">
      <van-tabbar-item replace to="/home" icon="home-o" @click="navigateTo('home')">首页</van-tabbar-item>
			<van-tabbar-item replace to="/course" icon="gem-o" @click="navigateTo('course')">课程</van-tabbar-item>
			<van-tabbar-item replace to="/test" icon="notes-o" @click="navigateTo('test')">练习</van-tabbar-item>
			<van-tabbar-item replace to="/exam" icon="records-o" @click="navigateTo('exam')">考试</van-tabbar-item>
<!--      <van-tabbar-item replace to="/webview?name=course" icon="gem-o" @click="navigateToWebview('https://readapi.bluebirdabc.com/lessonplayer/index.html?userId=1111&pid=&lessonId=80#/')">课程</van-tabbar-item>
      <van-tabbar-item replace to="/webview?name=test" icon="notes-o" @click="navigateToWebview('https://read2.bluebirdabc.com/exam/#/home?pid=w7398uoaiIAF98wu&cid=24')">练习</van-tabbar-item>
      <van-tabbar-item replace to="/webview?name=exam" icon="records-o" @click="navigateToWebview('https://read2.bluebirdabc.com/exam/#/home?pid=w7398uoaiIAF98wu&cid=24')">考试</van-tabbar-item> -->
<!--      <van-tabbar-item replace to="/webview?name=reading" icon="orders-o" @click="navigateToWebview('https://read2.bluebirdabc.com/exam/#/home?pid=w7398uoaiIAF98wu&cid=24')">阅读</van-tabbar-item> -->
			<van-tabbar-item replace icon="orders-o" @click="navigateTo('tool')">AI工具</van-tabbar-item>
      <van-tabbar-item replace to="/my" icon="user-o" @click="navigateTo('my')">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
      showIframe: false,
      iframeSrc: '',
      showTabbar: true, // 控制 Tabbar 的显示
    };
  },
  created() {
    this.checkRoute();
    // 监听课程包弹窗状态
    this.$eventBus.$on('packageModalChanged', this.handlePackageModalChange);
  },
  beforeDestroy() {
    this.$eventBus.$off('packageModalChanged', this.handlePackageModalChange);
  },
  watch: {
    $route(to) {
      this.checkRoute();
    },
  },
  methods: {
    checkRoute() {
      // 根据当前路由决定是否显示 Tabbar
      this.showTabbar = this.$route.path !== '/login'&&this.$route.path !== '/select'&&this.$route.path !== '/game'&&this.$route.path !== '/'&&this.$route.path !== '/wxCourseDetail'&&this.$route.path !== '/classReport';
    },
    // 处理课程包弹窗状态变化
    handlePackageModalChange(isShow) {
      if (this.$route.path === '/wxCourseDetail') {
        this.showTabbar = !isShow;
      }
    },
    navigateTo(route) {
      this.showIframe = false;
			if (this.$route.path === "/tool") {
					this.$eventBus.$emit('initPage');
			}
      this.$router.push({ path: `/${route}` });
    },
	// 调用这个方法加载网页到 iframe，前提是必须获得麦克风权限
	navigateToWebview(url) {
		console.dir(1111)
	  this.checkMicrophonePermission(url);  // 在执行iframe显示前，先检查麦克风权限
	},
	
	// 检查麦克风权限
	checkMicrophonePermission(url) {
	  if (navigator.permissions) {
		navigator.permissions.query({ name: 'microphone' }).then(permissionStatus => {
		  console.log('麦克风权限状态：', permissionStatus.state);
		  
		  if (permissionStatus.state === 'granted') {
			console.log('麦克风权限已授予');
			this.loadIframe(url);  // 已有麦克风权限，加载 iframe
		  } else if (permissionStatus.state === 'prompt') {
			console.log('请求用户授予麦克风权限');
			this.requestMicrophoneAccess(url);  // 请求用户授予权限
		  } else if (permissionStatus.state === 'denied') {
			console.log('麦克风权限被拒绝');
			alert('麦克风权限被拒绝，请在浏览器设置中手动开启。');
		  }

		  // 当权限状态变化时
		  permissionStatus.onchange = function() {
			console.log('麦克风权限状态改变为：', this.state);
		  };
		});
	  } else {
		console.log('该浏览器不支持权限查询');
		this.requestMicrophoneAccess(url); // 如果不支持权限查询，直接尝试请求权限
	  }
	},

	// 请求麦克风权限
	requestMicrophoneAccess(url) {
	  navigator.mediaDevices.getUserMedia({ audio: true })
		.then(function(stream) {
		  console.log('麦克风已启用');
		  this.loadIframe(url);  // 用户同意后加载 iframe
		}.bind(this))
		.catch(function(err) {
		  console.log('麦克风权限被拒绝:', err);
		});
	},

	// 加载 iframe 内容
	loadIframe(url) {
	  this.showIframe = true;
	  this.iframeSrc = url;
	},
	
	updateActive(newVal) {
      this.active = newVal;
    },
  },
};
</script>



<style lang="scss">
body{
	background: #F5F6FA;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.van-tabbar {
    height: 3.63rem!important; /* 你想要的高度 */
		.van-tabbar-item__icon{
			font-size: 1.8rem;
			margin-right: 0.6rem;
		}
		.van-tabbar-item{
			flex-direction: row;
			font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
			font-weight: 500;
			font-size: 1rem;
			color: #999999;
		}
}
</style>
